import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CardMedia from '@material-ui/core/CardMedia';

const useStyles = makeStyles({
    wrapper: {
        '@supports not (aspect-ratio: 16/9)': {
            position: 'relative',
            // Defaults to 16 / 9
            paddingBottom: 'calc(var(--aspect-ratio, .5625) * 100%)',
            height: 0,
        }
    },
    element: {
        aspectRatio: '16/9',
        border: 'none',
        '@supports not (aspect-ratio: 16/9)': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
        }
    },
})

// Intrisicly 16:9, overwrite the ratio by passing this in:
// <FluidVideo style={{'--aspect-ratio': '4 / 3;'}} />
const FluidVideo = ({style, data, title}) => {
    const classes = useStyles();

    return (
        <div className={classes.wrapper} style={style}>
            <CardMedia
                component='iframe'
                alt='vid'
                className={classes.element}
                src={data}
                title={title}
            />
        </div>
    )
};

export default FluidVideo;
